import { ListItem } from '../../gzSingleSelectList/types';

export interface GetItemsRequest {
  searchValue?: string;
  page?: number;
  limit?: number;
  extra?: any;
  feature?: string;
  context?: any;
  value?: string | number;
}

export interface GetItemsResponse {
  items: Array<ListItem>;
  totalItemsCount?: number;
  context?: any;
}

export enum SingleSelectComplexEvents {
  BACKEND_OPTIONS_LOADED = 'backendOptionsLoaded',
}

export enum SingleSelectFilterType {
  NONE = 'none', // by default, GzSingleSelectWebComponent is not a filter
  COMPANY = 'company',
  POLICY = 'policy',
}

export const DEFAULT_DATA_LIMIT = 10;
